import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./critical.css";

// Defer i18n — don't block first paint
import("./i18n");

// Load non-critical Tailwind utilities async
import("./index.css");

createRoot(document.getElementById("root")!).render(<App />);
